import script from "./ShoppingList.vue?vue&type=script&setup=true&name=ShoppingList&lang=js"
export * from "./ShoppingList.vue?vue&type=script&setup=true&name=ShoppingList&lang=js"

import "./ShoppingList.vue?vue&type=style&index=0&id=372e5a94&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-372e5a94"]])

export default __exports__